import React, { useState } from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import LoadingIndicator from "assets/svg/loading-indicator";
import { AiFillDelete } from "react-icons/ai";
import { useTranslation } from "react-i18next";

/**
 * Confirmation for removing a tag from your own page (from a pending "Delete" or
 * a decided "Remove from my page"). The parent supplies onConfirm, which does the
 * actual untag; this dialog only gates it. Copy matches the approval spec.
 */
export default function ConfirmRemoveTagModal({
  hide,
  taggerName = "",
  onConfirm = () => {},
  ...props
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleRemove = async () => {
    try {
      setLoading(true);
      await onConfirm();
      hide(true);
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const Footer = () => (
    <div className="relative grid gap-y-3 1sm:gap-y-0 1sm:flex 1sm:flex-row 1sm:items-center 1sm:justify-end 1sm:space-x-2">
      <Button
        buttonName={t("cancel", "Cancel")}
        buttonClass="bg-thBg py-5 px-12 "
        buttonTextClass="text-black text-xs 2sm:text-base font-semibold"
        onClick={() => hide()}
      />
      <Button
        buttonName={t("remove", "Remove")}
        buttonClass="bg-red py-5 px-12"
        buttonTextClass="text-white text-xs 2sm:text-base font-semibold flex items-center justify-center"
        onClick={() => handleRemove()}
        loadingIcon={loading ? <LoadingIndicator className="text-white w-4 h-4 ml-2" /> : null}
      />
    </div>
  );

  return (
    <Modal
      footer={<Footer />}
      width="w-19/20 md:w-16/20 2md:w-12/20 3md:w-9/20 1xl:w-8/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-gray">
      <div className="w-full">
        <div className="px-8.5 py-6">
          <div className="flex flex-row items-center">
            <AiFillDelete className="text-base 2sm:text-3xl text-red mr-3 md:mr-2" />
            <p className="text-base 2sm:text-3xl text-red font-bold tracking-tighter">
              {t("removeMilestoneFromPageTitle", "Remove this milestone from your page?")}
            </p>
          </div>
          <div className="w-full py-6">
            <p className="text-xs 2sm:text-lg">
              {t(
                "removeMilestoneFromPageBody",
                "You'll be untagged. It stays on {{tagger}}'s page."
              ).replace("{{tagger}}", taggerName || t("theTagger", "the tagger"))}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
}
